import p from "lodash-es/merge";
import T from "lodash-es/uniqueId";
import { ref as d, reactive as g, readonly as b } from "vue";
const h = 5e3, r = d([]);
function E(c = { timeout: h }) {
  function u(t) {
    r.value = r.value.filter(({ id: e }) => e !== t);
  }
  function n(t, e, v) {
    const i = p({}, c, v), o = T("toast-");
    return r.value.push({ text: t, id: o, status: e }), typeof i.timeout == "number" && setTimeout(() => u(o), Math.abs(i.timeout)), o;
  }
  function s() {
    r.value = [];
  }
  function f(t, e) {
    return n(t, "error", e);
  }
  function a(t, e) {
    return n(t, "info", e);
  }
  function m(t, e) {
    return n(t, "success", e);
  }
  function l(t, e) {
    return n(t, "warning", e);
  }
  return g({
    /**
     * The list of toasts that are currently visible.
     */
    active: b(r),
    /**
     * Removes an active/visible toast.
     */
    remove: u,
    /**
     * Creates a new toast and makes it active/visible.
     */
    create: n,
    /**
     * Removes all active/visible toasts.
     */
    removeAll: s,
    /**
     * Creates a new "error" toast.
     */
    error: f,
    /**
     * Creates a new "info" toast.
     */
    info: a,
    /**
     * Creates a new "success" toast.
     */
    success: m,
    /**
     * Creates a new "warning" toast.
     */
    warning: l
  });
}
export {
  h as DEFAULT_TIMEOUT,
  E as default
};
//# sourceMappingURL=useToasts.js.map
